export default __webpack_public_path__ + "static/brand_top_3-430cb62e0061054bddd6c5e43c68e818.png";